import { useEffect, useState } from 'react'
import styles from './EditCompanyPage.module.css'
import Navbar from '../../components/Navbar/Navbar'
import HeaderForCard from '../../components/HeaderForCard/HeaderForCard'
import UploadPhotoComponent from '../../components/UploadPhotoComponent/UploadPhotoComponent'
import s from '../../styles/common/Form.module.css'
import EditCardDescription from '../../components/EditCardDescription/EditCardDescription'
import Footer from '../../components/Footer/Footer'
import { useMediaQuery } from 'react-responsive'
import {
  changeCompanyDetails,
  deleteCurrentFileFromCompany,
  getCurrentCompany,
  pushNewFilesToCompany,
} from '../../redux/actions/companiesAction'
import Loader from '../../components/UI/Loader/Loader'
import { useAppDispatch, useAppSelector } from '../../redux/types/types'
import { useNavigate, useParams } from 'react-router-dom'
import { UploadImagesType } from '../../types'
import EditCompanyShortInformation from '../../components/EditCompanyShortInformation/EditCompanyShortInformation'
import EditCompanyLegalInformation from '../../components/EditCompanyLegalInformation/EditCompanyLegalInformation'
import exit from '../../assets/icons/trash.svg'
import MobileButtons from '../../components/UI/MobileButtons/MobileButtons'
import PATH from '../../navigation/path'
import { useToast } from '../../context/ToastContext'

const EditCompanyPage = () => {
  const [photos, setPhotos] = useState<UploadImagesType[]>([])
  const [photosFile, setPhotosFile] = useState<any[]>([])

  const { token } = useAppSelector((state) => state.auth)

  const { currentCompany, error, isLoading } = useAppSelector((state) => state.companies)
  const { showSuccess, showError } = useToast()

  const isMobile = useMediaQuery({ query: '(max-width: 767px)' })

  const { companyId } = useParams<{ companyId: string }>()

  const dispatch = useAppDispatch()
  const navigate = useNavigate()

  const handleDeleteImage = (e: any) => {
    const targetIndex = e.target.dataset.imgindex * 1
    setPhotos([...photos.slice(0, targetIndex), ...photos.slice(targetIndex + 1)])
  }

  const onUploadNewImages = async () => {
    const formData = new FormData()

    if (photosFile.length > 10) {
      showError('Вы можете загрузить максимум 10 картинок')

      return
    }

    if (photosFile.length !== 0) {
      for (let i = 0; i < photosFile.length; i++) {
        formData.append('images', photosFile[i])
      }

      const resultAction = await dispatch(
        pushNewFilesToCompany({ companyId: String(currentCompany.id), formData, token }),
      )

      if (pushNewFilesToCompany.rejected.match(resultAction)) {
        showError('Произошла ошибка при добавлении файлов')
        setPhotosFile([])
        setPhotos([])
      } else {
        showSuccess('Файлы успешно добавлены')
        setPhotosFile([])
        setPhotos([])
        await dispatch(getCurrentCompany({ companyId, token }))
      }
    }
  }

  const onResetHandler = () => {
    navigate(`${PATH.companyPage}${currentCompany.id}`)
  }

  const onDeleteImageFromServer = async (image: string) => {
    const resultAction = await dispatch(
      deleteCurrentFileFromCompany({
        token,
        companyId: String(currentCompany.id),
        filesToDelete: [image],
      }),
    )

    if (deleteCurrentFileFromCompany.rejected.match(resultAction)) {
      showError('Произошла ошибка при удалении файлов')
    } else {
      showSuccess('Файлы успешно удалены')
      await dispatch(getCurrentCompany({ companyId, token }))
    }
  }

  const onChangeCompanyCardDescription = async (newDescription: string) => {
    const resultAction = await dispatch(
      changeCompanyDetails({
        token,
        companyId: String(currentCompany.id),
        description: newDescription,
      }),
    )

    if (changeCompanyDetails.rejected.match(resultAction)) {
      showError('Произошла ошибка при изменении данных')
    } else {
      showSuccess('Данные успешно изменены')
      await dispatch(getCurrentCompany({ companyId: String(companyId), token }))
    }
  }

  useEffect(() => {
    dispatch(getCurrentCompany({ companyId, token }))
  }, [companyId, dispatch])

  if (isLoading) {
    return <Loader />
  }

  return (
    <div className={styles.editCompanyPage}>
      <Navbar />
      <div className={styles.imageContainer}>
        <HeaderForCard title={currentCompany.name} />
        {!isMobile && photos.length !== 0 && (
          <div className={styles.btnsBlock}>
            <div className={styles.editIconBlock} onClick={onUploadNewImages}>
              Ok
            </div>
          </div>
        )}
      </div>
      <div className={styles.imageUpload}>
        <UploadPhotoComponent
          editMode
          photos={photos}
          photosFile={photosFile}
          setPhotos={setPhotos}
          widthOneImageContainer={245}
          widthOneGapOfImageContainer={20}
          setPhotosFiles={setPhotosFile}
        >
          <>
            {currentCompany.images.length > 0 &&
              currentCompany.images.map((image, index) => {
                return (
                  <div className={styles.imagesContainer} key={index} data-imgindex={index + 100}>
                    <div className={styles.imageExitContainer}>
                      <img
                        className={styles.imageExit}
                        src={exit}
                        alt='exit'
                        onClick={() => onDeleteImageFromServer(image)}
                        data-imgindex={index}
                      />
                    </div>
                    <img
                      className={styles.image}
                      src={`${process.env.REACT_APP_BASE_URL_IMAGES}${image}`}
                      alt={image}
                    />
                  </div>
                )
              })}
            {photos.length > 0 &&
              photos.map((photo, index) => {
                return (
                  <div className={styles.imagesContainer} key={index} data-imgindex={index}>
                    <div className={styles.imageExitContainer}>
                      <img
                        className={styles.imageExit}
                        src={exit}
                        alt='exit'
                        onClick={handleDeleteImage}
                        data-imgindex={index}
                      />
                    </div>
                    <img className={styles.image} src={photo?.src} alt={photo.name} />
                  </div>
                )
              })}
          </>
        </UploadPhotoComponent>
        <>
          {error && <p className={`${s.errorValidation} ${s.networkError}`}>{error as string}</p>}
        </>
      </div>
      {isMobile && (
        <MobileButtons
          className={styles.mobileBtns}
          isValid={true}
          handleSubmit={onUploadNewImages}
          handleCancel={onResetHandler}
        />
      )}
      <div className={styles.container}>
        <div className={styles.content}>
          <EditCompanyShortInformation
            companyId={currentCompany.id}
            phone={currentCompany.contactPhone}
            email={currentCompany.email}
            address={currentCompany.address}
            city={currentCompany.city}
          />
          <EditCompanyLegalInformation
            companyId={currentCompany.id}
            companyName={currentCompany.name}
            inn={currentCompany.inn}
            role={currentCompany.role}
            contactFullName={currentCompany.contactFullName}
            contactPhone={currentCompany.contactPhone}
            email={currentCompany.email}
          />
          <EditCardDescription
            text={currentCompany.description ? currentCompany.description : ''}
            onSubmitHandler={onChangeCompanyCardDescription}
            onResetHandler={onResetHandler}
          />
        </div>
      </div>
      <Footer />
    </div>
  )
}

export default EditCompanyPage
